/* eslint-disable */
// AUTO-GENERATED - DO NOT EDIT
import { z, testRegex } from '@talbenmoshe/atlas-api/client';
export { toSnakeCase } from './caseTransform.js';
// ============ Component Validation Schemas ============
export const ServiceStatusResponseSchema = z.object({
    service: z.string(),
    databaseValue: z.string(),
}).loose();
export const StartEmailSignInRequestSchema = z.object({
    email: z.email().max(254),
}).strict();
export const EmailSignInStartedResponseSchema = z.object({
    resendAvailableAt: z.iso.datetime(),
    resendAvailableInSeconds: z.number().int().min(0),
}).loose();
export const TooManyCodesErrorSchema = z.object({
    reason: z.literal('too-many-codes'),
    resendAvailableAt: z.iso.datetime(),
    resendAvailableInSeconds: z.number().int().min(0),
}).loose();
export const VerifyEmailSignInRequestSchema = z.object({
    email: z.email().max(254),
    code: z.string().refine((val) => testRegex('^[0-9]{6}$', val), { message: 'Invalid format' }),
}).strict();
export const EmailSignInVerifiedResponseSchema = z.object({
    redirectTo: z.url(),
}).loose();
export const SignInRefusedErrorSchema = z.object({
    reason: z.enum(['wrong-code', 'code-expired', 'too-many-attempts']),
    attemptsLeft: z.number().int().min(1).max(4).optional(),
    resendAvailableAt: z.iso.datetime(),
    resendAvailableInSeconds: z.number().int().min(0),
}).loose();
// ============ Request Schemas ============
export const GetTripOsIdentityStatusRequestSchema = z.object({}).loose();
// ============ Response Schemas ============
export const ServiceStatusResponseResponseSchema = ServiceStatusResponseSchema;
export const EmailSignInStartedResponseResponseSchema = EmailSignInStartedResponseSchema;
export const EmailSignInVerifiedResponseResponseSchema = EmailSignInVerifiedResponseSchema;
// ============ Inferred Type Exports ============
// These types represent the transformed output (camelCase) from Zod schemas.
// Use these types for consumer-facing APIs instead of wire-format types.
//# sourceMappingURL=TripOsIdentityAPISchemas.js.map